import { SPACING_FROM_NEAREST_CORNER, SPACING_FROM_ANCHOR, ARROW_SIZE } from './constants.js';
import { PopoverContainer, Arrow } from './styles.js';
import { PopoverContentDisplayMode, PopoverInteractionType } from './types.js';
import { AnchoredLayerPosition, AnchoredLayerBoundariesElement, AnchoredLayerFlippedPositions, AnchoredLayer } from '@doordash/component-layer-manager';
import FocusLock from '@doordash/component-focus-lock';
import React from 'react';
import { ThemingContext } from '@doordash/design-language';
import { withUniqueId } from '@doordash/utilities';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var PREFIX_ID = 'Popover';

var getOffsetForPosition = function getOffsetForPosition(position, includeArrowSize) {
  var adjustedSpacing = includeArrowSize ? SPACING_FROM_ANCHOR : SPACING_FROM_ANCHOR - ARROW_SIZE;

  switch (position) {
    case AnchoredLayerPosition.TopLeft:
    case AnchoredLayerPosition.BottomLeft:
      return [-SPACING_FROM_NEAREST_CORNER, adjustedSpacing];

    case AnchoredLayerPosition.TopRight:
    case AnchoredLayerPosition.BottomRight:
      return [SPACING_FROM_NEAREST_CORNER, adjustedSpacing];

    case AnchoredLayerPosition.RightTop:
    case AnchoredLayerPosition.LeftTop:
      return [-SPACING_FROM_NEAREST_CORNER, adjustedSpacing * 1.5];

    case AnchoredLayerPosition.RightBottom:
    case AnchoredLayerPosition.LeftBottom:
      return [SPACING_FROM_NEAREST_CORNER, adjustedSpacing * 1.5];

    case AnchoredLayerPosition.TopCenter:
    case AnchoredLayerPosition.BottomCenter:
      return [0, adjustedSpacing];

    case AnchoredLayerPosition.RightCenter:
    case AnchoredLayerPosition.LeftCenter:
    default:
      return [0, adjustedSpacing * 1.5];
  }
};

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "context", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      arrowElement: undefined,
      isVisible: _this.props.defaultIsVisible || false,
      isFlipped: false
    });

    _defineProperty(_assertThisInitialized(_this), "isTargetWithinContainerOnMouseDown", false);

    _defineProperty(_assertThisInitialized(_this), "mouseDownFired", false);

    _defineProperty(_assertThisInitialized(_this), "anchorElement", void 0);

    _defineProperty(_assertThisInitialized(_this), "containerElement", void 0);

    _defineProperty(_assertThisInitialized(_this), "targetFlagResetTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "getActualPosition", function () {
      var position = _this.props.position;
      return _this.state.isFlipped ? AnchoredLayerFlippedPositions[position] // casting because this is set in defaultProps so it won't ever be `undefined`
      : position;
    });

    _defineProperty(_assertThisInitialized(_this), "setVisibility", function (visibility) {
      var isFunction = typeof visibility === 'function'; // If visibility is a function, keep a record of it's original
      // `isVisible` property to compare against the freshly updated state

      var previousVisibility = isFunction ? visibility(_this.state) : null;

      _this.setState(isFunction ? visibility : {
        isVisible: visibility
      }, function () {
        // Check to see if user passed in `onVisibilityChange` prop
        if (_this.props.onVisibilityChange) {
          // If `visibility` is a function (see `ToggleClick` case in
          // `getEventHandlersForInteractionType()` for example), we
          // only want to call `onVisibilityChange` if the newly
          // updated state is different than before (`previousVisibility`)
          if (isFunction) {
            if (previousVisibility && previousVisibility.hasOwnProperty('isVisible') && previousVisibility.isVisible !== _this.state.isVisible) {
              return _this.props.onVisibilityChange(_this.state.isVisible);
            } // If `visibility` is not a function, we only want to call
            // the `onVisibilityChange` callback if visibility is different
            // than the `isVisible` prop that was passed to `Popover`

          } else if (visibility !== _this.props.isVisible) {
            return _this.props.onVisibilityChange(visibility);
          }
        }

        return null;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAnchorElement", function (ref) {
      _this.anchorElement = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setContainerElement", function (ref) {
      _this.containerElement = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setArrowElement", function (ref) {
      _this.setState({
        arrowElement: ref
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEscapePress", function (e) {
      if (e.key === 'Escape') {
        _this.handleClose(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      } else {
        _this.setVisibility(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFlippedChange", function (_ref) {
      var flipped = _ref.flipped;
      return _this.setState({
        isFlipped: flipped
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_isElementWithinContainer", function (element) {
      return !!(element && (_this.containerElement && _this.containerElement.contains(element) || _this.anchorElement && _this.anchorElement.contains(element)));
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (e) {
      // clear reset timer because we are resetting the flag with a new value
      // immediately here
      clearTimeout(_this.targetFlagResetTimer); // setting a flag so the click handler knows mousedown actually happen
      // if not then the click handler will run its own check to see if the target
      // is within the container

      _this.mouseDownFired = true;
      _this.isTargetWithinContainerOnMouseDown = _this._isElementWithinContainer(e.target);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (e) {
      // If detail === 0 then we can assume a click event is synthetic from React via an Enter KeyDown on the trigger
      // https://github.com/facebook/react/issues/3907#issuecomment-363948471
      // This may have something to do with the way Class Components Handle the new batching in React 18.
      // https://github.com/reactwg/react-18/discussions/21
      // This works fine in React 16 + 17. TODO: Convert all class components to Functional.
      if ((e === null || e === void 0 ? void 0 : e.detail) === 0) {
        //We conditionally chain here to help enzyme / jest out.
        return;
      } // If mouseDownFired is false then the consumer is using `stopPropogation` on their mousedown event,
      // so we will run the container logic here as a last-ditch fallback


      var mouseDownSuppressed = !_this.mouseDownFired;
      var isTargetWithinContainer = !mouseDownSuppressed ? _this.isTargetWithinContainerOnMouseDown : _this._isElementWithinContainer(e.target); // If the target was not within the popover on mousedown, close the popover

      if (!isTargetWithinContainer) {
        _this.handleClose(e);
      } // There are some scenarios where multiple click events fire for one `mousedown` (for example
      // when a user clicks a `label` it will also trigger a click on the associated `input`).
      // Adding a debounce to the reset here so the flag is persists through the end of the user interaction


      clearTimeout(_this.targetFlagResetTimer);
      _this.targetFlagResetTimer = setTimeout(function () {
        // reset flag at end of click event
        _this.isTargetWithinContainerOnMouseDown = false; // reset mousedown flag

        _this.mouseDownFired = false;
      }, 300);
    });

    _defineProperty(_assertThisInitialized(_this), "getIsVisible", function () {
      var isVisible = _this.props.isVisible;
      return typeof isVisible === 'boolean' ? isVisible : _this.state.isVisible;
    });

    _defineProperty(_assertThisInitialized(_this), "getEventHandlersForInteractionType", function () {
      switch (_this.props.interactionType) {
        case PopoverInteractionType.ToggleClick:
          return {
            onClick: function onClick() {
              return _this.setVisibility(function (state) {
                return {
                  isVisible: !state.isVisible
                };
              });
            }
          };

        case PopoverInteractionType.Controlled:
        default:
          return {};
      }
    });

    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Need this on mount to properly handle the target parsing before the popover opens
      document.addEventListener('mousedown', this.handleMouseDown, false);

      if (this.getIsVisible()) {
        document.addEventListener('click', this.handleClickOutside, false);
        document.addEventListener('keyup', this.handleEscapePress, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleMouseDown, false);
      document.removeEventListener('click', this.handleClickOutside, false);
      document.removeEventListener('keyup', this.handleEscapePress, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // If the visibility has changed, remove existing event handlers than may have not been removed, then add new ones if popover is visible
      if (prevProps.isVisible !== this.props.isVisible || prevState.isVisible !== this.state.isVisible) {
        document.removeEventListener('click', this.handleClickOutside, false);
        document.removeEventListener('keyup', this.handleEscapePress, false);

        if (this.getIsVisible()) {
          document.addEventListener('click', this.handleClickOutside, false);
          document.addEventListener('keyup', this.handleEscapePress, false);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$context$Popover, _this$context$Colors, _this$context$BorderR, _this$context$Colors2;

      var _this$props = this.props,
          _this$props$boundarie = _this$props.boundariesElement,
          boundariesElement = _this$props$boundarie === void 0 ? null : _this$props$boundarie,
          content = _this$props.content,
          children = _this$props.children,
          _this$props$position = _this$props.position,
          position = _this$props$position === void 0 ? AnchoredLayerPosition.BottomCenter : _this$props$position,
          _this$props$contentDi = _this$props.contentDisplayMode,
          contentDisplayMode = _this$props$contentDi === void 0 ? PopoverContentDisplayMode.InlineFlex : _this$props$contentDi,
          uniqueId = _this$props.uniqueId,
          customOffset = _this$props.customOffset;
      var actualPosition = this.getActualPosition();
      var showContainerPointer = typeof this.props.showContainerPointer !== 'undefined' ? this.props.showContainerPointer : (_this$context$Popover = this.context.Popover) === null || _this$context$Popover === void 0 ? void 0 : _this$context$Popover.showContainerPointer;
      var offset = customOffset || getOffsetForPosition(actualPosition, showContainerPointer);
      var isVisible = this.getIsVisible();
      return /*#__PURE__*/React.createElement(AnchoredLayer, {
        offset: offset,
        position: position,
        arrowElement: showContainerPointer ? this.state.arrowElement : undefined,
        shouldEscapeWithAnchor: false,
        onFlippedChange: this.handleFlippedChange,
        boundariesElement: boundariesElement,
        setContentWidthAsAnchorWidth: this.props.setContentWidthAsAnchorWidth,
        content: isVisible && content && /*#__PURE__*/React.createElement(FocusLock, null, /*#__PURE__*/React.createElement(PopoverContainer, {
          theme: this.context,
          backgroundColor: (_this$context$Colors = this.context.Colors) === null || _this$context$Colors === void 0 ? void 0 : _this$context$Colors.PopoverContainerBackground,
          borderRadius: (_this$context$BorderR = this.context.BorderRadius) === null || _this$context$BorderR === void 0 ? void 0 : _this$context$BorderR.PopoverContainerDefault,
          ref: this.setContainerElement,
          position: actualPosition,
          id: uniqueId,
          tabIndex: -1
        }, showContainerPointer && /*#__PURE__*/React.createElement(Arrow, {
          backgroundColor: (_this$context$Colors2 = this.context.Colors) === null || _this$context$Colors2 === void 0 ? void 0 : _this$context$Colors2.PopoverContainerBackground,
          ref: this.setArrowElement,
          position: actualPosition
        }), content))
      }, /*#__PURE__*/React.createElement("div", _extends({
        style: {
          display: contentDisplayMode
        },
        ref: this.setAnchorElement
      }, this.getEventHandlersForInteractionType()), children({
        describedBy: undefined,
        // To-Do: Remove in v8
        accessibilityAttributes: {
          'aria-controls': isVisible ? uniqueId : undefined,
          'aria-haspopup': undefined,
          // To-Do: Remove in v8
          'aria-expanded': this.state.isVisible
        }
      })));
    }
  }]);

  return Popover;
}(React.Component);

_defineProperty(Popover, "contextType", ThemingContext);

_defineProperty(Popover, "Positions", AnchoredLayerPosition);

_defineProperty(Popover, "BoundariesElements", AnchoredLayerBoundariesElement);

_defineProperty(Popover, "ContentDisplayModes", PopoverContentDisplayMode);

_defineProperty(Popover, "InteractionTypes", PopoverInteractionType);

_defineProperty(Popover, "defaultProps", {
  defaultIsVisible: false,
  position: AnchoredLayerPosition.BottomCenter,
  boundariesElement: null,
  contentDisplayMode: Popover.ContentDisplayModes.InlineFlex,
  interactionType: Popover.InteractionTypes.ToggleClick,
  setContentWidthAsAnchorWidth: false
});

var PopoverWithUniqueID = withUniqueId(Popover, {
  prefix: PREFIX_ID
});
PopoverWithUniqueID.Positions = AnchoredLayerPosition;
PopoverWithUniqueID.BoundariesElements = AnchoredLayerBoundariesElement;
PopoverWithUniqueID.ContentDisplayModes = PopoverContentDisplayMode;
PopoverWithUniqueID.InteractionTypes = PopoverInteractionType;
PopoverWithUniqueID.defaultProps = Popover.defaultProps;

export { Popover, PopoverWithUniqueID as default };
